import mixinMutations from '@/store/mixins/segment/mutations'
import mixinActions from '@/store/mixins/segment/actions'
import mixinGetters from '@/store/mixins/segment/getters'

export default {
	namespaced: true,
	state: {
		all: {},
		common: {},
		segmentList: [],
		removed: [],
		lastlyRemoved: {},
		notValid: {
			fi: [],
			en: []
		},
		editing: null,
		gapActions: null	
	},
	getters: {
		...mixinGetters,
		editSource (state, getters, rootState, rootGetters) {
			return rootGetters.editSources.section
		}
	},
  mutations: mixinMutations,
	actions: {
		...mixinActions
	} 
}
